import React, {useState, useEffect}  from 'react'
import {useParams} from "react-router-dom"
import '@/assets/css/goods.scss';
import leftImg from '@/assets/img/icon/left.png'
import rightImg from '@/assets/img/icon/right.png'
import bagImg from '@/assets/img/icon/bag.png'
import { REQUEST } from "@/api";
import intl from 'react-intl-universal';
import Swiper from "swiper"
import "swiper/css/swiper.css"

const GoodsId = () => {
    const [goods, setGoods] = useState({})
    const [staticInfo, setStaticInfo] = useState([])
    const [mySwiper, setSwiper] = useState(null)
    const [swiperIndex, setSwiperIndex] = useState(1)
    const [qrImg, setQrImg] = useState('')
    const params = useParams()

    const fetchGoodsDetail = (code) => {
        const data = {
            type: intl.getInitOptions().currentLocale === 'zh-CN' ? '1' : '2',
            goodsCode: code
        }
        REQUEST('goodsDetail', data).then((res) => {
           setGoods(Object.assign({}, res.body))
        })
    }

    const changeSlide = (type) => {
        if (mySwiper) {
            if (type === 'next') {
                mySwiper.slideNext()
            } else {
                mySwiper.slidePrev()
            }
        }
    }

    useEffect(() => {
        setStaticInfo(intl.get('goods').detail)
        fetchGoodsDetail(params.id)
    }, [params.id])
    useEffect(() => {
        const swiper = new Swiper ('.swiper-container', {
            speed: 1000,
            observer: true,
            observeParents: true,
            autoplay: {
                delay: 3000,
                stopOnLastSlide: false,
                disableOnInteraction: false
            },
            on: {
                slideChange (t){
                    setSwiperIndex(this.realIndex + 1)
                }
            }
        })
        setSwiper(swiper)
    }, [])
    return (
        <div className="rl">
            {
                qrImg && (
                    <div className="mask">
                        <div className="goods-close-btn" onClick={() => {setQrImg("")}}/>
                        <div className="goods-qrcode flex-column">
                            <div className="img-box">
                                <img src={qrImg} alt=""/>
                            </div>
                            <div className="img-text">长按识别或下载二维码</div>
                        </div>
                    </div>
                )
            }
            <div className="rl-container rl-goods flex-column">
                <div className="goods-detail-head">
                    <div className="goods-title">{goods.goodsName}</div>
                    <div className="goods-des">
                        <span className="left">{goods.firstName}/</span>
                        <span className="right">{goods.threeName}</span>
                    </div>
                    <div className="goods-img">
                        <div className="img">
                         <div className="swiper-container">
                            <div className="swiper-wrapper">
                                {
                                    goods.images && goods.images.map((val) => {
                                        return (
                                            <div key={val} className="swiper-slide">

                                                    <img src={val} alt=""/>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                <div className="goods-detail-info">
                    <div className="info-ctrl flex-between">
                        <div className="ctrl" onClick={() => changeSlide('prev')}>
                            <img src={leftImg} alt=""/>
                        </div>
                        {
                            goods.images && (
                                <div className="ctrl-num">
                                    <span className="active">
                                        {
                                            swiperIndex > 9 ? swiperIndex : '0' + swiperIndex
                                        }
                                    </span>
                                    <span className="">/  {
                                        goods.images.length > 9 ? goods.images.length : '0' + goods.images.length
                                    }</span>
                                </div>
                            )
                        }
                        <div className="ctrl"  onClick={() => changeSlide('next')}>
                            <img src={rightImg} alt=""/>
                        </div>
                    </div>
                    <div className="info-item item1 flex-between">
                        <div className="left flex-justify-start">
                            <span className="desc-t">{staticInfo[0]}:</span>
                            <span className="desc">{goods.styleName}</span>
                        </div>
                        <div className="right flex-center">
                            <div className="img-box">
                                <img src={bagImg} alt=""/>
                            </div>
                        </div>
                    </div>
                    <div className="info-item item2 flex-between">
                        <div className="left flex-column-start">
                            <p className="desc-t">{staticInfo[1]}</p>
                            <p className="desc-c">RMB {goods.price}</p>
                        </div>
                        <div className="right" onClick={() => {setQrImg(goods.code)}}>
                            <p className="tip">Buy Now</p>
                        </div>
                    </div>
                    <div className="info-item item3 flex-between">
                        <div className="left flex-justify-start">
                            <span className="desc-t">{staticInfo[2]}:</span>
                            <span className="desc">{goods.color}</span>
                        </div>
                        <div className="right flex-justify-start">
                            <span className="desc-t">{staticInfo[3]}:</span>
                            <span className="desc">{goods.goodsCode}</span>
                        </div>
                    </div>
                    <div className="info-item item4">
                        <div className="left flex-justify-start">
                            <span className="desc-t">{staticInfo[4]}:</span>
                            <span className="desc">{goods.material}</span>
                        </div>
                    </div>
                    <div className="info-item item5 flex-column-start">
                        <div className="left flex-row-start">
                            <span className="desc-t">{staticInfo[5]}:</span>
                        </div>
                        <div className="left item5-1 flex-justify-start">
                            {goods.introduce}
                         </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default GoodsId
